// extracted by mini-css-extract-plugin
export var active = "_4k-7";
export var container = "_4k-0";
export var evenWidth = "_4k-4";
export var large = "_4k-5";
export var outlet = "_4k-8";
export var slide = "_4k-2";
export var small = "_4k-6";
export var tab = "_4k-3";
export var tabs = "_4k-1";